export const INVOICE_PRINT_DARK_STORAGE_KEY = "kothar_invoice_print_dark_theme";

const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach((listener) => listener(getInvoicePrintDarkTheme()));
};

export const subscribeInvoicePrintTheme = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getInvoicePrintDarkTheme = () => {
  try {
    return localStorage.getItem(INVOICE_PRINT_DARK_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const setInvoicePrintDarkTheme = (value) => {
  try {
    localStorage.setItem(INVOICE_PRINT_DARK_STORAGE_KEY, value ? "true" : "false");
  } catch {
    // ignore quota / private mode
  }
  notifyListeners();
};

export const getInvoicePrintPageStyle = (darkPrint) =>
  darkPrint
    ? `@page { size: auto; margin: 12mm; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; background: #1e293b !important; color: #f1f5f9 !important; }`
    : `@page { size: auto; margin: 12mm; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; background: #ffffff !important; color: #333333 !important; }`;

export const getInvoicePrintRootClassName = (darkPrint) =>
  `invoice-print-root ${darkPrint ? "invoice-print-dark" : "invoice-print-light"}`;
